import React from 'react';
import { Link } from 'react-router-dom';
import BotonGhostCuadrado from '../BotonGhostCuadrado/index';

import './css/styles.css';
import './css/w3.css';

class BannerUnidad extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            img_banner_inicio: '',
            url_banner_inicio: '',
        };
    }

    componentWillMount(){
        fetch('/api/uip/imagenes/banner/unidad', {
            method: 'GET',
            headers: {
                'Content-type': 'application-json'
            }
        })
            .then(response => response.json())
            .then(response => {
                this.setState({
                    img_banner_inicio: response[0].imagen,
                    url_banner_inicio: response[0].url,
                })
            })

    }

    render(){
        return(
            <div className="container_banner_unidad">
                <img className="img_banner_unidad" src={this.state.img_banner_inicio}></img>
                <div className="text_banner_unidad">
                    <Link to="/equipo">
                        <span className="link_text_banner_unidad hvr-pop">
                            {this.props.texto}
                        </span>
                    </Link>
                </div>
            </div>
        );
    }
}

export default BannerUnidad;